<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <div slot="operations">
          <el-form inline label-width="60px">
            <el-form-item :label="$t('SeaExport.Door')">
              <el-input v-model="form.doorName" style="width: 200px;" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.LoadingDate')">
              <el-date-picker v-model="form.loadingDateMin" type="date" value-format="yyyy-MM-dd" style="width: 100px;" />
              <el-date-picker v-model="form.loadingDateMax" type="date" value-format="yyyy-MM-dd" style="width: 100px;" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="toQuery">{{ $t('SeaExport.Query') }}</el-button>
            </el-form-item>
            <br>
            <el-form-item :label="$t('SeaExport.ShippingCompany')">
              <cargo-advance-select
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{seaCmp:true,active:true}"
                filterable
                :default-value="form.carrierId||''"
                style="width: 200px;"
                @parentCallBack="p=>{form.carrierId=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HaulageCompany')">
              <cargo-advance-select
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{seaCmp:true,truckCmp:true,active:true}"
                filterable
                :default-value="form.carryingCmp||''"
                style="width: 200px;"
                @parentCallBack="p=>{form.carryingCmp=p.value}"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :wrap-text="true"
            :row-data="rowData"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { queryLandTranQuery } from '@/api/seaExport/trucking'
import StrUtils from '@/utils/StrUtils'
import LandTransportationForm from '@/views/cargo/v0/SeaExport/LandTransportation/components/LandTransportationForm'
import CargoTemplateSelectDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { cache } from '@/utils/cacheManager'

export default {
  name: 'LandTranQuery',
  components: { CargoTemplateSelectDialog, LandTransportationForm, searchItem, cargoAdvanceSelect },
  data() {
    return {
      fullscreenLoading: false,
      selectTypeNames: TYPE_NAMES,
      gridParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.ShippingCompany'), field: 'carrierId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.LoadingDate'), field: 'loadingDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.HaulageCompany'), field: 'carryingCmp', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerDescription'), field: 'containerDesc', width: 200,
          cellRenderer: (params) => {
            return this.containerDescLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.HaulageCharge'), field: 'haulageCharge', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Door'), field: 'doorName', width: 200
        }
      ],
      rowData: [],
      filter: {
        pageNum: 1,
        pageSize: 30,
        total: 0
      },
      form: {
        carrierId: 0,
        carryingCmp: 0,
        doorName: '',
        loadingDateMin: '',
        loadingDateMax: ''
      }
    }
  },
  created() {
    this.toQuery()
  },
  methods: {
    toQuery() {
      const params = this.getQueryCondition()
      params.pageNum = this.filter.pageNum
      params.pageSize = this.filter.pageSize
      this.fullscreenLoading = getLoading()
      this.filter.branchId = this.$store.getters.currentOfficeId
      queryLandTranQuery(params).then(res => {
        this.filter.total = Number(res.data.total)
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.rowData = res.data.list
      }).finally(() => this.fullscreenLoading.close())
    },
    // 获取查询参数
    getQueryCondition() {
      const item = {}
      // 船公司
      if (this.form.carrierId > 0) {
        item.carrierId = this.form.carrierId
      }
      if (!StrUtils.isEmpty(this.form.doorName)) {
        item.doorName = this.form.doorName.trim()
      }
      if (this.form.carryingCmp > 0) {
        item.carryingCmp = this.form.carryingCmp
      }
      if (this.form.loadingDateMin) {
        item.loadingDateMin = this.form.loadingDateMin
      }
      if (this.form.loadingDateMax) {
        item.loadingDateMax = this.form.loadingDateMax
      }
      // 特定时间业务数据
      if (this.$checkPermission(['filter_SELandTranQuery_SetETDDate']) && !this.$store.getters.isAdmin) {
        // 配置参数ETD日期 LandTranQueryEtdParam
        const etdDate = cache.config.get('LandTranQueryEtdParam')
        if (etdDate) {
          item.etd = etdDate
        } else {
          const myDate = new Date()
          item.etd = myDate.getFullYear() + '-01-01'
        }
      }
      item.officeId = this.$store.getters.currentOfficeId
      return item
    },
    containerDescLabelFunc(value) {
      if (value) {
        return value.split('\n').join(',')
      } else {
        return null
      }
    }
  }
}
</script>

<style scoped>

</style>
